var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSigned = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 40C31.046 40 40 31.046 40 20C40 8.954 31.046 0 20 0C8.954 0 0 8.954 0 20C0 31.046 8.954 40 20 40ZM27.072 12.928C27.4475 12.553 27.9567 12.3425 28.4874 12.3429C29.0181 12.3433 29.527 12.5545 29.902 12.93C30.277 13.3055 30.4875 13.8147 30.4871 14.3454C30.4867 14.8761 30.2755 15.385 29.9 15.76L18.594 27.066L18.586 27.074C18.4007 27.2604 18.1804 27.4083 17.9377 27.5092C17.695 27.6101 17.4348 27.6621 17.172 27.6621C16.9092 27.6621 16.649 27.6101 16.4063 27.5092C16.1636 27.4083 15.9433 27.2604 15.758 27.074L15.75 27.066L10.1 21.416C9.90898 21.2315 9.75662 21.0108 9.6518 20.7668C9.54698 20.5228 9.49181 20.2604 9.4895 19.9948C9.48719 19.7292 9.53779 19.4659 9.63836 19.2201C9.73892 18.9743 9.88742 18.751 10.0752 18.5632C10.263 18.3754 10.4863 18.2269 10.7321 18.1264C10.9779 18.0258 11.2412 17.9752 11.5068 17.9775C11.7724 17.9798 12.0348 18.035 12.2788 18.1398C12.5228 18.2446 12.7435 18.397 12.928 18.588L17.172 22.83L27.072 12.93V12.928Z",
  fill: "url(#paint0_linear_39711_48961)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_39711_48961",
  x1: -1.80758,
  y1: -13.0121,
  x2: 49.8894,
  y2: -8.70105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.182952,
  stopColor: "#32BB71"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A9D8F"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSigned);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_signed.79410c4f4fc403cde0728a960b7a33f4.svg";